<template>
  <div class="home">
    <div class="text-center">
      <img src="/static/img/simnach_logo.png" height="300" width="700" class="rounded" alt="...">
    </div>
  </div>
</template>

<script lang="ts">
import { Client } from '@/components/api';
import { Options, Vue } from 'vue-class-component';

@Options({})
export default class HomeView extends Vue {
  todo: string[] | string = '';
  mounted() {
    this.todo = this.$route.params.todo;
    if (this.todo == 'drop') {
      this.dropCollection()
    } else if (this.todo == 'seed') {
      this.seed()
    }
  }

  async dropCollection() {
    try {
      const recordResponse = await Client.get('/api_backend/v1/admin/drop_api');
      this.$toast.open({
        message: recordResponse.data.message,
        type: 'success',
        position: 'top-right',
        duration: 3000,
      });
    } catch (e: any) {
      this.$toast.open({
        message: `Error : ${e?.response?.data?.err}`,
        type: 'warning',
        position: 'top-right',
        duration: 3000,
      });
    }
  }

  async seed() {
    try {
      const recordResponse = await Client.get('/api_backend/v1/admin/seed_api');
      this.$toast.open({
        message: recordResponse.data.message,
        type: 'success',
        position: 'top-right',
        duration: 3000,
      });
    } catch (e: any) {
      this.$toast.open({
        message: `Error : ${e?.response?.data?.err}`,
        type: 'warning',
        position: 'top-right',
        duration: 3000,
      });
    }
  }
}
</script>
